module.exports = Promise.all([__parcel__import__("2svxS"), __parcel__import__("cCPkw")]).then(() => parcelRequire('4qady'));